export default "__VITE_ASSET__DsTg55Zj__"